import $ from "jquery";
export class ButtonSpinner {
    constructor(e) {
        var _a;
        this.allButtons = [];
        if ("target" in e) {
            const form = $(e.target);
            const submitter = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.submitter;
            const submitButton = submitter
                ? $(submitter)
                : form.find("button[type='submit']").first();
            this.spinnerButton = submitButton;
            this.allButtons = form
                .find("button")
                .toArray()
                .map((b) => {
                const button = $(b);
                return {
                    button,
                    disabled: button.prop("disabled"),
                };
            });
        }
        else {
            this.spinnerButton = e;
            this.allButtons = [
                {
                    button: e,
                    disabled: e.prop("disabled"),
                },
            ];
        }
        this.spinner = $($("[data-ajax-button-spinner]").html());
    }
    show() {
        this.allButtons.forEach((o) => o.button.prop("disabled", true));
        this.spinnerButton.addClass("spinner").append(this.spinner);
    }
    hide() {
        this.spinnerButton.removeClass("spinner");
        this.allButtons.forEach((o) => o.button.prop("disabled", o.disabled));
        this.spinner.remove();
    }
}
